module.exports = __webpack_public_path__ + "img/flj.051e76ff.png";